import { apiClient } from './client';
import { MateriaPrima } from '../types';

export interface DadosMateriaPrima {
  nome: string;
  unidade_medida: string;
  custo_unitario?: number | string;
  estoque_atual?: number | string;
}

export function listarMateriasPrimas(): Promise<MateriaPrima[]> {
  return apiClient.get('/materias-primas').then((res) => res.data.materias_primas);
}

export function criarMateriaPrima(dados: DadosMateriaPrima): Promise<MateriaPrima> {
  return apiClient.post('/materias-primas', dados).then((res) => res.data.materia_prima);
}

export function atualizarMateriaPrima(id: number, dados: DadosMateriaPrima): Promise<MateriaPrima> {
  return apiClient.put(`/materias-primas/${id}`, dados).then((res) => res.data.materia_prima);
}

export function removerMateriaPrima(id: number): Promise<{ ok: boolean }> {
  return apiClient.delete(`/materias-primas/${id}`).then((res) => res.data);
}
